// Web shim for react-native-safe-area-context
import React, { createContext, useContext } from 'react';
import { View } from 'react-native';

// Web 版本：安全区域始终为 0
const defaultInsets = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
};

const defaultFrame = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
};

export const useSafeAreaInsets = () => {
  return defaultInsets;
};

export const useSafeAreaFrame = () => {
  return defaultFrame;
};

// Contexts
export const SafeAreaInsetsContext = createContext(defaultInsets);
export const SafeAreaFrameContext = createContext(defaultFrame);

// Initial window metrics
export const initialWindowMetrics = {
  insets: defaultInsets,
  frame: defaultFrame,
};

export const SafeAreaProvider = ({ children }: { children: React.ReactNode }) => {
  return React.createElement(
    SafeAreaInsetsContext.Provider,
    { value: defaultInsets },
    React.createElement(
      SafeAreaFrameContext.Provider,
      { value: defaultFrame },
      children
    )
  );
};

export const SafeAreaView = ({ children, style, ...props }: any) => {
  return React.createElement(View, { style, ...props }, children);
};

export default {
  SafeAreaProvider,
  SafeAreaView,
  useSafeAreaInsets,
  useSafeAreaFrame,
  SafeAreaInsetsContext,
  SafeAreaFrameContext,
  initialWindowMetrics,
};
